import styled from 'styled-components';

interface WrapperDisableProps {
  isDisabled?: boolean;
}

export const Wrapper = styled.div<WrapperDisableProps>`
  font-size: 11px;
  font-weight: 500;
  letter-spacing: -0.11px;
  line-height: 16px;
  border-radius: 0 0 0 5px;
  padding: 5px 4px;
  height: 24px;
  display: flex;
  align-items: center;
  gap: 4px;

  background: ${({ isDisabled }) => (isDisabled ? '#F5F5F5' : '#FFE7BA')};
`;
